import React from 'react'
import ReactDOM from 'react-dom'
import 'regenerator-runtime/runtime.js'

import App from './App'

import './index.scss'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)
